// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { attributesStyles } from "@rpsc/Overrides/Widgets/ProductDetails/ProductDetailsAttributes";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

attributesStyles.wrapper = {
    css: css`
        display: flex;
        gap: 22px;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
    `,
};

attributesStyles.tableContainer = {
    css: css`
        display: flex;
        flex: 1;
        ${xScreen("lte", "sm")} {
            width: 100%;
            flex-grow: 1;
        }
        @media print {
            flex: 1;
            width: 100%;
        }
    `,
};

attributesStyles.table = {
    css: css`
        tr:nth-child(odd) {
            background: ${color("common.ui2")};
        }
        tr:nth-child(even) {
            background: ${color("common.white")};
        }
    `,
};

attributesStyles.valueCell = {
    css: css`
        text-wrap: wrap;
        width: 50%;
    `,
};

attributesStyles.label = {
    weight: fontConfig.weight.bold,
    css: css`
        &&&& {
            font-size: 14px;
            line-height: 22px;
            white-space: break-spaces;
        }
        &::after {
            content: ":";
        }
    `,
};

attributesStyles.value = {
    css: css`
        &&&& {
            font-size: 14px;
            line-height: 22px;
            white-space: normal;
        }
    `,
};
